export default "__VITE_ASSET__Mexz0CUx__"